export default "__VITE_ASSET__58050426__"